
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "IOTOMP",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/IOTOMP.vue